{
    "CxiLicenceType_SOLO": "Solo",
    "CxiLicenceType_TEAMS": "Ploegen",
    "CxiLicenceType_CXI": "CX-integratie",
    "CxiLicenceType_NONE": "Geen",
    "NAME": "CxiLicenceTypes"
}